/* 🤖 this file was generated by svg-to-ts */
export const svgOpenExternal: {
    name: "open-external";
    data: string;
} = {
    name: "open-external",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__open-external" viewBox="0 0 12 12"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="ng__path-open-external" transform="translate(-319 -20) translate(320 21) translate(.658 .68)"><path d="M2.7644 0 0 0 0 8.8571 8.7453 8.8571 8.7453 6.3798"/><g transform="translate(3.486 .035)"><path d="M0 5.216 5.141.071"/><path d="M2.2507.012857 5.2029.012857 5.2029 2.965"/></g></g></g></symbol></svg>`,
};
